import { render, staticRenderFns } from "./ConsultManage.vue?vue&type=template&id=5968056a&"
import script from "./ConsultManage.vue?vue&type=script&lang=js&"
export * from "./ConsultManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports